"use client";

import React from "react";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";

import BusinessHero from "../../components/business/BusinessHero";
import BusinessSectionMice from "../../components/business/BusinessSectionMice";
import BusinessSectionAccommodation from "../../components/business/BusinessSectionAccommodation";
import BusinessSectionCafeteria from "../../components/business/BusinessSectionCafeteria";
import BusinessSectionCatering from "../../components/business/BusinessSectionCatering";
import BusinessSectionMerchandise from "../../components/business/BusinessSectionMerchandise";
import BusinessSectionDaycare from "../../components/business/BusinessSectionDaycare";
import BusinessSectionOthers from "../../components/business/BusinessSectionOthers";

export default function BusinessIndexPage() {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        <BusinessHero />

        <BusinessSectionMice />
        <BusinessSectionAccommodation />
        <BusinessSectionCafeteria />
        <BusinessSectionCatering />
        <BusinessSectionMerchandise />
        <BusinessSectionDaycare />
        <BusinessSectionOthers />
      </main>

      <Footer />
    </div>
  );
}